import { saveItem } from 'core/redux/actions/localStorage/localStorageActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type {
  LocalStorageSectionsEntityHierarchyVisualizationPositions} from 'entityHierarchy/redux/reducers/entityHierarchyReducer';
import {
  changeViewSettings,
  changeVisualizationPosition,
  LOCAL_STORAGE_ENTITY_HIERARCHY_VISUALIZATION_POSITIONS
} from 'entityHierarchy/redux/reducers/entityHierarchyReducer';
import type { AnyAction,Middleware } from 'redux';

const entityHierarchyMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  // Sync multiple sections visualization positions with local storage
  if (changeVisualizationPosition.match(action) || changeViewSettings.match(action)) {
    const newVisualizationPositions: LocalStorageSectionsEntityHierarchyVisualizationPositions = {};

    const state = (store.getState() as ApplicationState).entityHierarchy;

    Object.keys(state).forEach((sectionId) => {
      if (changeVisualizationPosition.match(action)) {
        // Section id
        newVisualizationPositions[sectionId] = {
          ...state[sectionId].visualizationPositions,
          // View id: updated by the action
          [action.payload.data.id]: {
            ...(state[sectionId].visualizationPositions[action.payload.data.id] || {}),
            nodesPositions: action.payload.data.nodesPositions,
            viewPosition: action.payload.data.viewPosition,
          },
        };
      }

      if (changeViewSettings.match(action)) {
        // Section id
        newVisualizationPositions[sectionId] = {
          ...state[sectionId].visualizationPositions,
          // View id: updated by the action
          [action.payload.data.id]: {
            ...(state[sectionId].visualizationPositions[action.payload.data.id] || {}),
            viewSettings: action.payload.data.viewSettings,
          },
        };
      }
    });

    store.dispatch(saveItem({
      id: LOCAL_STORAGE_ENTITY_HIERARCHY_VISUALIZATION_POSITIONS,
      data: newVisualizationPositions,
    }));
  }

  next(action);
};

export default entityHierarchyMiddleware;
